import EmailHero from '../components/GetStarted/EmailHero';
import EmailInputPanel from '../components/GetStarted/EmailInputPanel';

export default function GetStartedPage() {
  return (
    <div className="w-full bg-background-main rounded-lg rounded-b-none border border-background-main pb-16 mx-auto py-4 lg:py-14 flex flex-col justify-center items-center px-4 lg:px-11 bg-gradient-light dark:bg-gradient-dark bg-no-repeat bg-cover">
      <div className="flex flex-col md:flex-row md:justify-between max-w-[1260px] w-full mx-auto">
        <EmailHero />
        <EmailInputPanel />
      </div>
    </div>
  );
}
